import React, { FC, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import { InvoiceHeaderToolbar } from "./InvoiceHeaderToolbar";
import { Button, Icon } from "../../common";
import { ROUTES } from "../../../routes";
import type { Invoice } from "../../../types/InvoiceTypes";

type Props = {
  data: Invoice;
};

export const FormHeader: FC<Props> = ({ data }) => {
  const navigate = useNavigate();

  const onDelete = useCallback(() => {
    navigate(data?.user_is_payer ? ROUTES.PAY : ROUTES.RECEIVE);
  }, [data?.user_is_payer, navigate]);

  return (
    <header className="flex flex-row w-full items-center justify-between">
      <Button
        rounded
        component={NavLink}
        to={data?.user_is_payer ? ROUTES.PAY : ROUTES.RECEIVE}
      >
        <span className="flex flex-row items-center justify-start gap-x-6 font-manrope text-base whitespace-nowrap">
          <Icon icon="Arch" size={24} className="text-gray-500" disableFill />
          Back to dashboard
        </span>
      </Button>

      <div className="theme-text-secondary mr-auto ml-12">
        <span className="mr-3">💾</span>We auto-save invoices
      </div>

      <InvoiceHeaderToolbar
        publicView={false}
        onDelete={onDelete}
        tooltip={true}
      />
    </header>
  );
};
